import { readPersisted, writePersisted } from "./stopwatchStorage";
import { getDateKey } from "shared/utils/date";
import { StopwatchStartResult } from "../domain/types/stopwatch.types";

export const startStopwatch = (maxSeconds: number): StopwatchStartResult => {
  const p = readPersisted();
  const today = getDateKey();

  if (p.sessionDateKey !== today && p.sessionAccumulated > 0) {
    return { ok: false, reason: "previous_day_session" };
  }

  if (p.sessionAccumulated >= maxSeconds) {
    return { ok: false, reason: "daily_cap_reached" };
  }

  const isNewSession = p.sessionAccumulated === 0;
  const newDateKey = isNewSession ? today : p.sessionDateKey;
  const now = Date.now();

  writePersisted({
    ...p,
    isRunning: true,
    startedAt: now,
    sessionDateKey: newDateKey,
    sessionStartedAt: isNewSession ? now : p.sessionStartedAt,
  });

  return { ok: true };
};

export const pauseStopwatch = () => {
  const p = readPersisted();

  if (!p.isRunning || !p.startedAt) return;

  const delta = Math.floor((Date.now() - p.startedAt) / 1000);
  const accumulated = p.sessionAccumulated + delta;

  writePersisted({
    ...p,
    isRunning: false,
    startedAt: null,
    sessionAccumulated: accumulated,
  });
};

export const clearStopwatchSession = () => {
  const today = getDateKey();

  writePersisted({
    isRunning: false,
    startedAt: null,
    sessionAccumulated: 0,
    sessionDateKey: today,
    sessionStartedAt: null,
  });
};

